import React, { useState, useMemo } from 'react';
import PropTypes from 'prop-types';

import { DataTable, TextField, Icon, Button, ButtonGroup } from '@shopify/polaris'
import { DeleteMajorMonotone, ArrowUpMinor, ArrowDownMinor, PlusMinor } from '@shopify/polaris-icons'
import { FieldArray } from 'formik';

const propTypes = {
  headings: PropTypes.arrayOf(PropTypes.string).isRequired,
  tableRows: PropTypes.arrayOf(
    PropTypes.shape({
      id: PropTypes.string,
      values: PropTypes.arrayOf(PropTypes.string),
    })
  ).isRequired,
  handleChange: PropTypes.func.isRequired,

  onChangePosition: PropTypes.func.isRequired,
  onRemoveItem: PropTypes.func.isRequired,
  onAddNew: PropTypes.func.isRequired,
}

const defaultProps = {

}

const TableRowsForm = (props) => {

  const columnContentTypes = useMemo( () => [
    ...props.headings.map(heading => "text"),
    "text", // actions
  ] 
  [props.headings.length]);

  const headings = [
    ...props.headings,
    "", // actions
  ]

  // Build TextFields for each row (filter nulls for _destroy marks)
  const currentRowsCount = props.tableRows.length;
  const rows = props.tableRows.map( (tableRow, rowIndex) => {
    // This is one tableRow "table_rows.0.values.0, table_rows.0.values.1"
    console.log("TableRow", tableRow);
    if(tableRow._destroy){
      return null
    }

    const itemCells = props.headings.map( (_headingName, index) => (
      <TextField
        id={`resource_table_rows.${rowIndex}.values[${index}]`}
        name={`resource_table_rows.${rowIndex}.values[${index}]`}
        type="text"
        onChange={ props.handleChange }
        value={ tableRow.values[index] }
      />
    ))

    console.log("RI", rowIndex);

    const actions = (
    <ButtonGroup segmented>
      <Button onClick={ () => props.onChangePosition(tableRow, rowIndex, "UP") } disabled={ rowIndex <= 0 }>
        <Icon source={ ArrowUpMinor } />
      </Button>
      <Button onClick={ () => props.onChangePosition(tableRow, rowIndex, "DOWN") } disabled={ rowIndex == (currentRowsCount - 1) }>
        <Icon source={ ArrowDownMinor } />
      </Button>
      <Button onClick={ () => props.onAddNew(rowIndex) } >
        <Icon source={ PlusMinor } />
      </Button>
      <Button destructive onClick={ () => props.onRemoveItem(tableRow, rowIndex) } >
        <Icon source={ DeleteMajorMonotone } />
      </Button>
    </ButtonGroup>
    )

    // Add extra cell with actions
    return [
      ...itemCells,
      actions,
    ]
  }).filter( (rowArray) => !!rowArray );

  return (
    <div>
      <DataTable
        rows={ rows }
        headings={ headings }
        columnContentTypes={ columnContentTypes }
      />
    </div>
  )
};

TableRowsForm.propTypes = propTypes;
TableRowsForm.defaultProps = defaultProps;

export default TableRowsForm;